const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgMergedAreaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: "53.612mm",
    height: "40.212mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5361.2 4021.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0099ff",
      fillRule: "nonzero"
    },
    d: "M3552.7 2188.18l305.13 276.54c74.59,67.49 80.35,182.67 12.87,257.26 -67.48,74.6 -182.67,80.36 -257.26,12.87l-634.29 -574.87c-40.31,-36.48 -60.51,-86.88 -59.92,-137.28 -0.54,-5.76 -0.83,-11.58 -0.83,-17.47 0,-59.93 28.83,-113.15 73.39,-146.52l621.65 -563.42c74.59,-67.48 189.78,-61.73 257.26,12.87 67.48,74.59 61.72,189.78 -12.87,257.26l-283.43 256.87c492.37,0 1093.79,-0.13 1586.13,-0.13 101.02,0 182.94,81.91 182.94,182.94 0,101.03 -81.92,182.94 -182.94,182.94 -499.55,0 -1108.22,0.14 -1607.83,0.14zm-1750.87 0l-305.13 276.54c-74.59,67.49 -80.35,182.67 -12.87,257.26 67.48,74.6 182.67,80.36 257.26,12.87l634.29 -574.87c40.31,-36.48 60.51,-86.88 59.92,-137.28 0.54,-5.76 0.83,-11.58 0.83,-17.47 0,-59.93 -28.83,-113.15 -73.39,-146.52l-621.65 -563.42c-74.59,-67.48 -189.78,-61.73 -257.26,12.87 -67.48,74.59 -61.72,189.78 12.87,257.26l283.43 256.87c-492.37,0 -1093.79,-0.13 -1586.13,-0.13 -101.02,0 -182.94,81.91 -182.94,182.94 0,101.03 81.92,182.94 182.94,182.94 499.55,0 1108.22,0.14 1607.83,0.14z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergedAreaIcon);
export default __webpack_public_path__ + "static/media/merged_area_icon.35f2aebe2a550a0e0f75d1b36c09ff03.svg";
export { ForwardRef as ReactComponent };